module.exports = __webpack_public_path__ + "img/1440.009a54a3.jpg";